window.AvailabilityMatrixAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    self.save = function (appId, data) {
        var deferred = $q.defer();
        
        var payload = {
        	days: data
        };
        
        _protected.request('applications/' + appId + '/availability_matrix', 'PUT', payload).then(function (data) {
            _protected.handleResponse(data.data, deferred);
        }, function(err){
            deferred.reject(err);
        });
        
        return deferred.promise;
    };
});